var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container-sitc" }, [
    _c("div", { staticClass: "filter-container-content" }, [
      _c("div", { staticStyle: { padding: "0 40px" } }, [
        _c("span", { staticClass: "title-h4" }, [
          _vm._v(_vm._s(_vm.$t("userCenter.sendFailGuidebook.title"))),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("table", [
            _c("tr", [
              _c("td", { staticClass: "table-left" }, [
                _vm._v(
                  _vm._s(_vm.$t("userCenter.sendFailGuidebook.tabTitle1"))
                ),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "table-right" }, [
                _vm._v(_vm._s(_vm.$t("userCenter.sendFailGuidebook.tabTips1"))),
              ]),
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "table-left" }, [
                _vm._v(
                  _vm._s(_vm.$t("userCenter.sendFailGuidebook.tabTitle2"))
                ),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "table-right" }, [
                _vm._v(_vm._s(_vm.$t("userCenter.sendFailGuidebook.tabTips2"))),
              ]),
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("tr", [
              _c("td", { staticClass: "table-left" }, [
                _vm._v(
                  _vm._s(_vm.$t("userCenter.sendFailGuidebook.tabTitle3"))
                ),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "table-right" }, [
                _vm._v(_vm._s(_vm.$t("userCenter.sendFailGuidebook.tabTips3"))),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }